import Vue from "vue";
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

const options = {
    
    theme: {
        themes: {
            light: {
                primary: "#008aad",
                secondary: colors.orange.base,
                accent: colors.blue.base,
                error: colors.red.base,
                warning: colors.deepOrange.base,
                info: colors.cyan.base,
                success: colors.green.base
            },
            dark: {
                primary: "#008aad",
                secondary: colors.orange.base,
                accent: colors.blue.base,
                error: colors.red.base,
                warning: colors.deepOrange.base,
                info: colors.cyan.base,
                success: colors.green.base
            },
        }
    },
    icons: {
        iconfont: "mdiSvg"
    }
};

export default new Vuetify(options);
